import {
    select as D3select,
    dispatch as D3dispatch,
    local as D3local,
    easeSin as D3easeSin,
    easeLinear as D3easeLinear,
} from 'd3';
import { LetContextMenu } from './utils';
/*
    expects: {key, crdn, size}
*/
const D3PulsatingDot = function () {
    let color;
    let projection;
    let scale = 1;
    let animate = false;
    let theme;

    const dispatch = D3dispatch('mouseover', 'mouseout', 'click');
    let self;
    const dotSize = (d, i, a, size) => (size || d.size) / scale;

    // stash previous values in a local map, we'll be animating when that changes
    const previous = D3local();

    function my (selection) {
        if (!selection) return;
        selection.each(function (data, i) {
            self = this;

            const getCount = d => d && d.count ? d.count.actual : 0;

            let g = D3select(self).selectAll('.brcpulsatingdot').data([data], d => d.key);
            g = g.enter()
                .append('g').attr('class', 'brcpulsatingdot')
                .merge(g);

            const pjoin = g.selectAll('circle.animated').data([data], d => d.key);
            pjoin.exit().remove();
            const penter = pjoin.enter()
                .append('circle')
                .attr('class', 'animated')
                .each(function (d) {
                    previous.set(this, getCount(d));
                });

            penter.style('opacity', 0.6)
                .transition()
                .duration(theme.transitions.duration.rippleSpeed)
                .ease(D3easeSin)
                .style('opacity', 1);

            penter.merge(pjoin)
                .attr('r', dotSize)
                .attr('cx', d => projection(d.crdn)[0])
                .attr('cy', d => projection(d.crdn)[1])
                .attr('fill', color)
                .on('mouseover', function (e, d) {
                    return dispatch.call('mouseover', my, { ...{ node: D3select(this).node() }, ...d });
                })
                .on('mouseout', function (e, d) {
                    return dispatch.call('mouseout', my, { ...{ node: D3select(this).node() }, ...d });
                })
                .on('mousedown', LetContextMenu)
                .on('click', function (e, d) {
                    return dispatch.call('click', my, { ...{ node: D3select(this).node() }, ...d });
                })
                .each(function (d) {
                    if (getCount(d) !== previous.get(this)) {
                        if (animate) {
                            ripple(this, d, 0);
                        } else {
                            D3select(this)
                                .transition()
                                .duration(theme.transitions.duration.complex)
                                .style('opacity', 0.6)
                                .transition()
                                .duration(theme.transitions.duration.rippleSpeed)
                                .ease(D3easeSin)
                                .style('opacity', 1);
                        }
                    }
                    previous.set(this, getCount(d));
                });

            function ripple (selection, d, repeat) {
                if (repeat > 2) return;
                g.append('circle')
                    .attr('class', 'ring')
                    .attr('cx', d => projection(d.crdn)[0])
                    .attr('cy', d => projection(d.crdn)[1])
                    .attr('r', dotSize)
                    .style('stroke-width', 2 / scale)
                    .style('stroke', color)
                    .style('fill', 'none')
                    .style('pointer-events', 'none')
                    .transition()
                    .duration(theme.transitions.duration.rippleFade)
                    .ease(D3easeLinear) // expand, thin out, and fade away
                    .style('stroke-opacity', 1e-6)
                    .style('stroke-width', 0.5 / scale)
                    .style('stroke', color)
                    .attr('r', 40 / scale)
                    .on('end', () => ripple(selection, d, repeat + 1))
                    .remove();
            }
        });
    }

    // getters/setters
    my.color = function (v) {
        if (!arguments.length) return color;
        color = v;
        return my;
    };

    my.projection = function (v) {
        if (!arguments.length) return projection;
        projection = v;
        return my;
    };

    my.scale = function (v) {
        if (!arguments.length) return scale;
        scale = v;
        return my;
    };

    my.animate = function (v) {
        if (!arguments.length) return animate;
        animate = v;
        return my;
    };

    my.theme = function (v) {
        if (!arguments.length) return theme;
        theme = v || theme;
        return my;
    };

    my.on = function () {
        const value = dispatch.on.apply(dispatch, arguments);
        return value === dispatch ? my : value;
    };

    return my;
};

export default D3PulsatingDot;
